import styled from 'styled-components';

export const DivGlobalStyled = styled.div`
  background-color: #e4ffdd;
  padding: 1% 1.5em;
  border-radius: 1em;
  display: flex;
  margin: 1em 50px;
  align-items: center;
  gap: 1em;

  @media (max-width: 768px) {
    padding: 1em;
    margin: 1em;
    gap: 1.5em;
  }

  @media (max-width: 480px) {
    padding: 1em 0.75em;
    margin: 0.75em;
    flex-direction: column;
  }
`;

export const DivStyled = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.25rem;
  width: 100%;
  color: #338033;
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
  text-align: left;
  font-size: 13px;
  margin: 1em;
  padding: 0 1em;
  max-width: 80%;
  flex: 1 1 auto;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
    max-width: 100%;
    padding: 0;
    text-align: center;
    margin: 0 0 0.5em;
  }

  @media (max-width: 480px) {
    font-size: 12px;
  }

  p {
    margin: 0;
  }
`;
